import type { CarFleetViewRecord } from '@navio/nsdk';

/** Wheels on the tire hotel tie the car to a running contract, so ownership cannot end from here. */
export const isCarOnTireHotel = (car: CarFleetViewRecord) => car.wheelStorage.length > 0;
